import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vulcan-talent/artifacts/83u122rz_ChatGPT%20Image%20Mar%2015%2C%202026%2C%2007_35_42%20PM.png";

const quickLinks = [
  { href: '/about', label: 'About Us' },
  { href: '/employers', label: 'For Employers' },
  { href: '/candidates', label: 'For Candidates' },
  { href: '/sectors', label: 'Our Sectors' },
  { href: '/jobs', label: 'Current Jobs' },
  { href: '/contact', label: 'Contact' },
];

const sectors = [
  'Construction',
  'Engineering',
  'Trades',
  'Industrial',
  'Infrastructure',
  'Mining Support',
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl font-bold text-white uppercase mb-4">Vulcan Recruitment</h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Specialist recruitment agency supporting construction, engineering, trades and industrial hiring across Melbourne, Victoria and Australia.
            </p>
            <div className="flex flex-col gap-3">
              <a 
                href="tel:+61469362319" 
                className="flex items-center gap-3 text-slate-300 hover:text-[#1A8B9D] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4 text-[#F5A623]" />
                +61 469 362 319
              </a>
              <a 
                href="mailto:info@vulcanrecruitment.com" 
                className="flex items-center gap-3 text-slate-300 hover:text-[#1A8B9D] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-[#F5A623]" />
                info@vulcanrecruitment.com
              </a>
              <div className="flex items-start gap-3 text-slate-300">
                <MapPin className="w-4 h-4 text-[#F5A623] mt-1 flex-shrink-0" />
                <span>Thomastown, Victoria, Australia</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6 text-white">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-slate-400 hover:text-[#1A8B9D] transition-colors text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sectors */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6 text-white">
              Sectors
            </h4>
            <ul className="space-y-3">
              {sectors.map((sector) => (
                <li key={sector}>
                  <Link 
                    to="/sectors"
                    className="text-slate-400 hover:text-[#1A8B9D] transition-colors text-sm"
                  >
                    {sector}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6 text-white">
              Business Hours
            </h4>
            <div className="space-y-3 text-sm text-slate-400">
              <div className="flex justify-between">
                <span>Monday - Friday</span>
                <span className="text-slate-300">8:00 AM - 6:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span>Saturday</span>
                <span className="text-slate-300">By Appointment</span>
              </div>
              <div className="flex justify-between">
                <span>Sunday</span>
                <span className="text-slate-300">Closed</span>
              </div>
            </div>
            <div className="mt-8">
              <Link 
                to="/employers#request-staff"
                className="inline-block bg-[#1A8B9D] hover:bg-[#115E6B] text-white font-bold py-3 px-6 uppercase tracking-wide text-sm transition-colors"
                data-testid="footer-cta"
              >
                Request Staff Now
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Vulcan Recruitment. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link 
                to="/privacy" 
                className="text-slate-500 hover:text-slate-300 text-sm transition-colors"
                data-testid="footer-privacy"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="text-slate-500 hover:text-slate-300 text-sm transition-colors"
                data-testid="footer-terms"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
